export default function rgbToHex(r: number, g: number, b: number) {
  return Number((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1);
}
